<div class="p-g form-container">
    <form [formGroup]='chagePasswordForm'>
        <div>
            <div class="p-g">
                <div class="form-field p-g-12 p-MD-12 p-lg-12">
                    <div class="form-errors alert alert-danger" [hidden]='!passwordError[0]["general"]'>
                        <div *ngFor="let ErrorMessage of passwordError['general']">
                            {{ErrorMessage.message}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-g">
                <div class="form-field p-g-12">
                    <div class="form-label p-g-12">
                        <label for="oldPassword" id="ariaLabelOldPassword">Old Password</label>
                    </div>
                    <div class="form-control p-g-12">
                        <input type="password" pInputText formControlName="oldPassword" id="oldPassword" #oldPassword
                            aria-labelledby="ariaLabelOldPassword ariaLabelErrorOldPassword" aria-required="true" />
                    </div>
                    <div class="form-errors" id="ariaLabelErrorOldPassword"
                        *ngIf="chagePasswordForm.controls.oldPassword.errors  && (chagePasswordForm.controls.oldPassword.dirty || chagePasswordForm.controls.oldPassword.touched || submitted)">
                        <div [hidden]="!chagePasswordForm.controls.oldPassword.errors.required" translate>
                            old_password_required
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-g">
                <div class="form-field p-g-12">
                    <div class="form-label p-g-12">
                        <label for="newPassword" id="ariaLabelNewPassword">New Password</label>
                    </div>
                    <div class="form-control p-g-12">
                        <input type="password" pInputText formControlName="newPassword" id="newPassword"
                            aria-labelledby="ariaLabelNewPassword ariaLabelErrorNewPassword" aria-required="true" />
                    </div>
                    <div id="ariaLabelErrorNewPassword" class="form-errors"
                        *ngIf="(chagePasswordForm.controls.newPassword.errors && (chagePasswordForm.controls.newPassword.dirty || chagePasswordForm.controls.newPassword.touched || submitted)) || isPasswordMismatch">
                        <div [hidden]="!chagePasswordForm.controls.newPassword.errors" translate>
                            new_password_required
                        </div>
                        <div class="form-errors" [hidden]="!isPasswordMismatch" translate>
                            password_mismatch
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-g">
                <div class="form-field p-g-12">
                    <div class="form-label p-g-12">
                        <label for="newConfirmPassword" id="ariaLabelNewConformPassword">New Confirm Password</label>
                    </div>
                    <div class="form-control p-g-12">
                        <input type="password" pInputText formControlName="newConfirmPassword" id="newConfirmPassword"
                            aria-labelledby="ariaLabelNewConformPassword ariaLabelErrorNewConformPassword"
                            aria-required="true" />
                    </div>
                    <div id="ariaLabelErrorNewConformPassword" class="form-errors"
                        *ngIf="chagePasswordForm.controls.newConfirmPassword.errors  && (chagePasswordForm.controls.newConfirmPassword.dirty || chagePasswordForm.controls.newConfirmPassword.touched || submitted)">
                        <div [hidden]="!chagePasswordForm.controls.newConfirmPassword.errors.required" translate>
                            confirm_password_required
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-g">
                <div class="form-buttons p-g-12">
                    <button pButton type="button" label="Save" icon="fa fa-check" (click)="doChangePassword()"></button>
                    <button class="negative-button" pButton type="button" icon="fa fa-close" label="Cancel"
                        (click)="onCancel()"></button>
                </div>
            </div>
        </div>
    </form>
</div>
